import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=04ad9492"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=04ad9492&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ad9492')) {
      api.createRecord('04ad9492', component.options)
    } else {
      api.reload('04ad9492', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=04ad9492", function () {
      api.rerender('04ad9492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorFinal/Index.vue"
export default component.exports